import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";

@Component
export class DataTableMixin extends Vue {
  pagination = {
    page: 1,
    pageCount: 0,
    perPage: 10,
    total: 0,
    skipped: 0
  };

  fetchData() {}

  // @Watch("pagination.perPage")
  handleLimitChanged(limit: number) {
    this.pagination.perPage = limit;
    this.pagination.page = 1;
    this.fetchData();
  }

  handlePagination(page: number) {
    this.pagination.page = page;
    this.fetchData();
  }
}
